var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0076 6.75499L3.1851 31.5C2.87949 32.0292 2.71779 32.6293 2.71608 33.2404C2.71437 33.8515 2.87271 34.4525 3.17534 34.9834C3.47798 35.5144 3.91437 35.9568 4.44109 36.2667C4.96781 36.5767 5.5665 36.7433 6.1776 36.75H35.8226C36.4337 36.7433 37.0324 36.5767 37.5591 36.2667C38.0858 35.9568 38.5222 35.5144 38.8249 34.9834C39.1275 34.4525 39.2858 33.8515 39.2841 33.2404C39.2824 32.6293 39.1207 32.0292 38.8151 31.5L23.9926 6.75499C23.6806 6.24068 23.2414 5.81545 22.7172 5.52034C22.193 5.22523 21.6016 5.07019 21.0001 5.07019C20.3986 5.07019 19.8072 5.22523 19.283 5.52034C18.7588 5.81545 18.3196 6.24068 18.0076 6.75499Z",
    stroke: "#163165",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.75V22.75",
    stroke: "#163165",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.75H21.0199",
    stroke: "#163165",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.b70fe21a39f3648717c3b2e521572bdf.svg";
export { ForwardRef as ReactComponent };